export enum ConnectedIntegrationStatusEnum {
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  NOT_STARTED = 'NOT_STARTED',
}
